<ng-container *translateBlock="let t">
  <section class="mobile-navigation-bg"
           (click)="closeMobileView()"
           [style.display]="openMenu && isMobileView ? 'block' : 'none'">
  </section>

  <section class="navigation"
           [class.active]="openMenu"
           [class.mobile]="isMobileView">
    <div class="navigation-actions">
      <app-button-icon iconName="groups"
                       [label]="t('common.title.user')"
                       class="labeled"
                       [routerLink]="['/super-console']"
                       routerLinkActive="active"
                       (click)="closeMobileView()"
                       [routerLinkActiveOptions]="{exact: true}" />

      <app-button-icon iconName="extension"
                       [label]="t('common.title.docker-services')"
                       class="labeled"
                       [routerLink]="['/super-console/docker-services']"
                       (click)="closeMobileView()"
                       routerLinkActive="active" />

      <app-button-icon iconName="bigtop_updates"
                       [label]="t('common.title.mqtt')"
                       class="labeled"
                       [routerLink]="['/super-console/mqtt']"
                       (click)="closeMobileView()"
                       routerLinkActive="active" />

      <app-button-icon iconName="cloud_lock"
                       [label]="t('common.title.azure')"
                       class="labeled"
                       [routerLink]="['/super-console/azure']"
                       (click)="closeMobileView()"
                       routerLinkActive="active" />

      <!--    <app-button-icon iconName="error"-->
      <!--                     label="Error-Logs"-->
      <!--                     class="labeled"-->
      <!--                     [routerLink]="['/super-console/error-logs']"-->
      <!--                     (click)="closeMobileView()"-->
      <!--                     routerLinkActive="active" />-->
    </div>
    <button class="toggle-button"
            [style.display]="isMobileView ? 'flex' : 'none'"
            (click)="toggleMobileView()">
    <span class="material-symbols-rounded">
      {{ openMenu ? 'chevron_left' : 'chevron_right' }}
    </span>
    </button>
  </section>
</ng-container>
